module.exports = __webpack_public_path__ + "available jobs dental.svg?9c04fa804a0cfcbcbda244ea3471c915";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/available jobs dental.svg
// module id = 35
// module chunks = 0